import { AgencyCapacityFillingStatus, AgentWorkload } from '../../types';

import {
    CollectCapacityReminder,
    CollectCapacityReminderContext,
} from './CollectCapacityReminderConfigurator';
import { AgencyCapacityNeedToBeFilledConfigurator } from './configurator/AgencyCapacityNeedToBeFilledConfigurator';
import { NoFeedbackForTwoWeeksConfigurator } from './configurator/NoFeedbackForTwoWeeksConfigurator';
import { OverloadedForTwoDaysConfigurator } from './configurator/OverloadedForTwoDaysConfigurator';

export class CollectCapacityReminderProvider {
    private readonly lastAgentWorkload: AgentWorkload;
    private readonly agencyCapacityFillingStatus: AgencyCapacityFillingStatus;
    private readonly isImpersonated: boolean;

    constructor(
        lastAgentWorkload: AgentWorkload,
        agencyCapacityFillingStatus: AgencyCapacityFillingStatus,
        isImpersonated: boolean,
    ) {
        this.lastAgentWorkload = lastAgentWorkload;
        this.agencyCapacityFillingStatus = agencyCapacityFillingStatus;
        this.isImpersonated = isImpersonated;
    }

    public evaluateNextReminder(): CollectCapacityReminder | null {
        if (this.isImpersonated) {
            return null;
        }

        const configurators = [
            new AgencyCapacityNeedToBeFilledConfigurator(),
            new OverloadedForTwoDaysConfigurator(),
            new NoFeedbackForTwoWeeksConfigurator(),
        ];

        const context: CollectCapacityReminderContext = {
            agentWorkload: this.lastAgentWorkload,
            agencyCapacityFillingStatus: this.agencyCapacityFillingStatus,
        };

        const eligibleConfigurators = [];
        for (const configurator of configurators) {
            if (configurator.support(context)) {
                eligibleConfigurators.push(configurator);
            }
        }

        let earliestReminder: CollectCapacityReminder | null = null;

        for (const configurator of eligibleConfigurators) {
            const reminder = configurator.get(context);
            if (reminder && (!earliestReminder || reminder.remindAt < earliestReminder.remindAt)) {
                earliestReminder = reminder;
            }
        }

        return earliestReminder;
    }
}
